// extracted by mini-css-extract-plugin
module.exports = {"regularPrice":"NonSubscribableDetails_regularPrice__3SRtM","crossed":"NonSubscribableDetails_crossed__7A0TO","priceOff":"NonSubscribableDetails_priceOff__1QPoB"};